import React, { useEffect, useState, useMemo } from "react";
import BasicTable from "../Components/Global_Components/reacttable/table";
import { useSelector, useDispatch } from "react-redux";
import {
  sidebar,
  patientid,
  updatePatientTab,
  updatePrescriptionId,
  updatePrescriptionType,
  setEmptyTemplateHtml,
  setEmptyTemplateEdit,
  setTemplateName,
} from "../Redux/Slice/rootSlice";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  getPrescriptionHistory,
  getSpecificPrescriptionTemplate,
  fetchPatientDetailsUuid,
} from "../Redux/Thunk/Actions";
import { useNavigate } from "react-router-dom";

function PatientPrescriptionHistory(props) {
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [dataCount, setDataCount] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [tableHeaderData, setTableHeaderData] = useState([]);
  const selectedTab = useSelector((state) => state.counter.patientTab);
  const prescriptionId = useSelector((state) => state.counter.prescriptionId);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedTab === "History") {
    }
    const fetchData = async () => {
      console.log("going in");
      const dataPayload = {
        page: dtpageindex,
        page_size: dtpagesize,
        patient_id: props.patientId,
        skipBranchFilter: true,
      };
      props.loaderchange?.("true");
      const patentDetails = getPrescriptionHistory(dataPayload);
      const responsePatentDetails = await dispatch(patentDetails);
      let records = [];
      let total = 0;
      if (responsePatentDetails?.payload?.status?.code === 200) {
        records = [...(responsePatentDetails.payload.data.data || [])];
        total = responsePatentDetails.payload.total_count || 0;
      }

      // Check if coupled patient (and not oocyte freezing), and retrieve partner's records as well
      const isOocyteFreezing =
        (props.patientData?.purpose || '').toLowerCase().includes('oocyte') ||
        (props.patientData?.purpose || '').toLowerCase().includes('freezing');
      const uhid = props.patientData?.p_uhid;

      // Mirror CouplePatientInfo's detection: if the UHID search returns ≥2 patients,
      // it's a couple — no need for couple_id to be present on the current patient object.
      if (uhid && !isOocyteFreezing) {
        try {
          const partnerAction = fetchPatientDetailsUuid({ p_uhid: uhid });
          const partnerRes = await dispatch(partnerAction);
          if (partnerRes.payload?.status?.code === 200) {
            const list = partnerRes.payload.data?.data || [];
            // Only proceed if 2 partners returned (confirmed couple) OR couple_id is set
            const coupleId = props.patientData?.couple_id ||
              list[0]?.couple_id || list[1]?.couple_id;
            const partner = list.find((p) => p.id !== props.patientId);
            if (partner?.id && (list.length >= 2 || coupleId)) {
              const partnerPayload = {
                page: dtpageindex,
                page_size: dtpagesize,
                patient_id: partner.id,
                skipBranchFilter: true,
              };
              const partnerHistoryAction = getPrescriptionHistory(partnerPayload);
              const partnerHistoryRes = await dispatch(partnerHistoryAction);
              if (partnerHistoryRes?.payload?.status?.code === 200) {
                const partnerRecords = partnerHistoryRes.payload.data.data || [];
                const map = new Map();
                records.forEach((r) => map.set(r.id, r));
                partnerRecords.forEach((r) => map.set(r.id, r));
                records = Array.from(map.values()).sort(
                  (a, b) => new Date(b.created_at) - new Date(a.created_at)
                );
                total = map.size;
              }
            }
          }
        } catch (e) {
          console.error("Error fetching couple partner prescription history:", e);
        }
      }

      if (records.length > 0) {
        setTableHeaderData(records);
        setDataCount(total);
        props.loaderchange?.("false");
      } else {
        props.loaderchange?.("false");
        props.popupalert?.("true");
        props.popuptext?.("No Data Available");
        setTimeout(() => {
          props.popupalert?.("false");
        }, 2000);
      }
    };
    fetchData();
  }, [selectedTab, dtpageindex, dtpagesize, dataCount, searchQuery, props.patientData?.p_uhid, props.patientData?.couple_id]);

  console.log(tableHeaderData);

  const handleViewChange = (original) => {
    dispatch(updatePrescriptionId(original.id));
    dispatch(setEmptyTemplateEdit(false));
    navigate("/viewHistory");
    console.log(original);
  };
  const handleEditChange = (original) => {
    dispatch(setTemplateName(original.template_type));

    dispatch(updatePrescriptionId(original.id));
    // if (original.template_type==="Prescription") {
    //   dispatch(updatePrescriptionType("Empty Page"))
    //   dispatch(setEmptyTemplateEdit(true))
    // }else{

    dispatch(updatePrescriptionType("Edit Prescription"));

    // }
    // *----

    const handleThunk = async (props) => {
      const payload = original.id;
      const patentDetails = getSpecificPrescriptionTemplate(payload);
      const response = await dispatch(patentDetails);
      if (response?.payload?.status?.code === 200) {
        console.log(response.payload.data.prescription_template, "ttftftftf");
        // the below line is to concatinating  RilReportTemplate and RilReportTemplateTwo if the selected report is rilReport
        response.payload.data.second_prescription_template == null
          ? dispatch(
              setEmptyTemplateHtml(response.payload.data.prescription_template)
            )
          : dispatch(
              setEmptyTemplateHtml(
                response.payload.data.prescription_template +
                  response.payload.data.second_prescription_template
              )
            );
      }
    };

    handleThunk();

    // *----
    navigate("/prescription");
  };

  const columns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: "",
        Cell: (row) => {
          const final_value = row.row.original.created_at.slice(0, 10);
          const [year, month, day] = final_value.split("-");
          const formattedDate = `${day}-${month}-${year}`;
          console.log(formattedDate);
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(formattedDate)}
                >
                  {String(formattedDate)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Time",
        accessor: "",
        Cell: (row) => {
          // const inputDateTime = "2023-11-08T07:35:00.730468Z";
          // const date = new Date(inputDateTime);
          // const hours = date.getHours();
          // const minutes = date.getMinutes();
          // const formattedHours = hours.toString().padStart(2, "0");
          // const formattedMinutes = minutes.toString().padStart(2, "0");
          // const time = `${formattedHours}:${formattedMinutes}`;
          const date = new Date(row.row.original.created_at);
          const hours = date.getHours();
          const minutes = date.getMinutes();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          let formattedHours = (hours % 12).toString().padStart(2, "0");
          formattedHours = formattedHours === "00" ? "12" : formattedHours;
          const formattedMinutes = minutes.toString().padStart(2, "0");
          const time = `${formattedHours}:${formattedMinutes} ${amOrPm}`;
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(time)}
                >
                  {String(time)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Prescription Type",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(row.row.original.template_type)}
                >
                  {String(row.row.original.template_type)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Revised",
        accessor: "",
        Cell: (row) => {
          const final_value = row.row.original.modified_at.slice(0, 10);
          const [year, month, day] = final_value.split("-");
          const formattedDate = `${day}-${month}-${year}`;
          console.log(formattedDate);
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="my-tooltip"
                  data-tooltip-content={String(formattedDate)}
                >
                  {String(formattedDate)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          return (
            <div className="style">
              <button
                type="button"
                class="btn btn-danger btn-sm delete"
                style={{ display: "flex", gap: "4px" }}
                onClick={(e) => handleViewChange(row.row.original)}
              >
                <i
                  // onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                  class="bi bi-eye-fill"
                ></i>{" "}
                View
              </button>
              {
                // row.row.original.template_type ==="Prescription" &&
                <button
                  type="button"
                  class="btn btn-danger btn-sm delete"
                  style={{ display: "flex", gap: "4px" }}
                  onClick={(e) => handleEditChange(row.row.original)}
                >
                  <i
                    // onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                    class="bi bi-pencil-square"
                  ></i>{" "}
                  Edit
                </button>
              }
            </div>
          );
        },
      },
    ],
    [dataCount]
  );
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  return (
    <>
      <div className="pageBody" style={{ width: "100%" }}>
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="table-patient">
                  <BasicTable
                    columns={columns}
                    data={tableHeaderData}
                    pagesize={pagesize}
                    pageindex={pageindex}
                    dtpagesize={dtpagesize}
                    dtpageindex={dtpageindex}
                    datacount={dataCount}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
    </>
  );
}

export default PatientPrescriptionHistory;
